import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'lr-initializing',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './initializing.component.html',
  styleUrls: ['./initializing.component.scss']
})
export class InitializingComponent {
  // Purely presentational component - no business logic
}
